import GlassCard from '@/components/GlassCard';
import { SectionData } from '@/types';
import { CheckCircle } from 'lucide-react';
import React from 'react';

interface QuickAccessSectionProps {
    section: SectionData;
    onClick: () => void;
}

const QuickAccessSection: React.FC<QuickAccessSectionProps> = ({
    section,
    onClick,
}) => {
    return (
        <GlassCard
            as="button"
            onClick={onClick}
            className="group relative flex w-full items-center gap-3 p-3 shadow-lg hover:border-[var(--color-theme-primary)]"
        >
            {/* Completion badge */}
            {section.is_completed && (
                <div className="absolute top-2 right-2">
                    <CheckCircle
                        size={20}
                        className="text-gray-400 dark:text-neutral-500"
                    />
                </div>
            )}

            <div
                className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl p-2"
                style={{
                    boxShadow:
                        'inset 0 3px 8px rgba(0,0,0,0.22), inset 0 1px 4px rgba(0,0,0,0.15)',
                }}
            >
                <img
                    src={section.icon_url || '/static/img/conquie-libro.png'}
                    alt={section.title}
                    className="h-full w-full object-contain"
                />
            </div>

            {/* Title */}
            <span className="text-left text-[14px] leading-[17.5px] font-medium tracking-[-0.02px] text-gray-600 dark:text-neutral-200">
                {section.title}
            </span>
        </GlassCard>
    );
};

export default QuickAccessSection;
